module.exports = __webpack_public_path__ + "img/acasia-looping.1a1c8065.gif";